import styled from '@emotion/styled';
import { Data, DotLottieReact } from '@lottiefiles/dotlottie-react';

export type AnimationContainerProps = {
  json?: Data;
  lottie?: string;
  height?: number;
};

const StyledAnimation = styled('div')<{ height: number }>(({ height }) => ({
  maxHeight: height,
  height: '100%',
}));

const StyledAnimationContainer = styled('div')(({ theme }) => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
}));

export const AnimationContainer = ({
  json,
  lottie,
  height = 150,
}: AnimationContainerProps) => {
  return (
    <StyledAnimationContainer>
      <StyledAnimation height={height}>
        <DotLottieReact
          loop
          autoplay
          src={lottie}
          data={json}
          height={height}
        />
      </StyledAnimation>
    </StyledAnimationContainer>
  );
};
